export default __webpack_public_path__ + "static/media/noapplyicon.f40ef11b.png";